<div class="trial-container" [formGroup]="parentForm">

  <!--  Trial / Patient Code-->
  <div class="row">
    <div class="col-12 col-lg-6">
      <label>Trial {{ index + 1 }}</label>
      <div class="form-group">
        <span [class.visibility-hidden]="!added" class="fake-field">{{ selectedTrialLabel }}</span>
        <div [class.visibility-hidden]="added" class="trial-autocomplete">
          <app-trial-autocomplete #trialAutocomplete controlName="trialCode" [showApiEnabledTrials]="true" placeholder="Select a public trial code..."
                                  [form]="parentForm" [liveTrials]="true" (valueChanged)="setFakeFieldValue($event)"></app-trial-autocomplete>
        </div>
        <p *ngIf="!parentForm.get('trialIdIsUnique').value && parentForm.get('trialId').value !== ''"
           class="validation-error" style="padding-left: 15px; padding-top: 3px;">This trial is
          already assigned to the patient, please select another trial.</p>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label>Patient Code</label>
        <input class="form-control" formControlName="patientCode" id="patientCode" maxlength="16" type="text" style="width: 100%;">
      </div>
    </div>
  </div>

  <!-- Site / Status on Trial -->
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
          <label>Site</label>
          <div *ngIf="added && canChangeSite" style="margin-bottom: .5rem;"><a href="#" style="font-size: 11px;" (click)="$event.preventDefault(); changingSite ? onCancelChangeSite() : changingSite = true">{{ changingSite ? 'Cancel' : 'Change Site' }}</a></div>
        </div>
        <span [class.visibility-hidden]="!added || changingSite" class="fake-field">{{ selectedSiteLabel }}</span>
        <div [class.visibility-hidden]="(added && !changingSite) || isLoadingChangeSitePreview">
          <app-site-dropdown
            formControlName="siteId"
            [trialId]="parentForm.get('trialId').value"
            [trialIdRequired]="true"
            [assignedOnly]="true"
            [unassignedOnly]="false"
            [approvedOnly]="true"
            [clearable]="!changingSite"
            (selected)="setFakeSiteFieldValue($event)"/>
        </div>
        <div *ngIf="isLoadingChangeSitePreview" style="display: flex; align-items: center; padding: 6px 0;">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label>Status on Trial</label>
        <app-dropdown-input #stateOnTrialSelect [parentForm]="parentForm" name="stateOnTrial"
                            [options]="stateOnTrialOptions" placeholder="Select..."></app-dropdown-input>
      </div>
    </div>
  </div>

  <!-- Intercash Remote Id -->
  <div class="row" *ngIf="patientTrial?.imsLegacyTrial">
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label>Intercash Remote Id</label>
        <input class="form-control" formControlName="intercashRemoteId" id="intercashRemoteId" maxlength="50" type="text" style="width: 100%;">
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label>Intercash SAN Number</label>
        <input class="form-control" formControlName="intercashSanNumber" id="intercashSanNumber" maxlength="50" type="text" style="width: 100%;">
      </div>
    </div>
  </div>

  <!-- Engine size / Reason for ending participation -->
  <div class="row">
    <div class="col-12 col-lg-6" [hidden]="!engineSizes.length">
      <div class="form-group">
        <label>Vehicle Engine Size</label>
        <app-dropdown-input #engineSizeSelect id="engineSize" [options]="engineSizes"
                            [parentForm]="parentForm" name="engineSize" placeholder="Select engine size"></app-dropdown-input>
      </div>
    </div>
    <div class="col-12" *ngIf="endingParticipationReasonVisible">
      <div class="form-group">
        <label>Reason for ending participation</label>
        <textarea style="width: 100% !important; min-height: 50px !important;" rows="2" class="form-control" formControlName="endingParticipationReason"
                  id="endingParticipationReason"></textarea>
      </div>
    </div>
  </div>

  <!-- Options -->
  <div class="row">
    <div class="col-12">
      <div class="options-toggle" (click)="onToggleOptions()" [class.visibility-hidden]="!added">
        <span>Options</span>
        <i class="far fa-angle-down" *ngIf="!optionsVisible"></i>
        <i class="far fa-angle-up" *ngIf="optionsVisible"></i>
      </div>
    </div>
    <div class="row" [class.visibility-hidden]="!optionsVisible">
      <div class="col-4">
        <div class="checkbox-wrap">
          <div class="form-group">
            <label class="checkbox">
              <input formControlName="bankFeesIncurred" id="bankFeesIncurred" type="checkbox">
              <span></span>
            </label>
            <label class="checkbox-label" for="bankFeesIncurred">Bank fees incurred</label>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="checkbox-wrap">
          <div class="form-group">
            <label class="checkbox">
              <input formControlName="approvalNoReceipts" id="approvalNoReceipts" type="checkbox">
              <span></span>
            </label>
            <label class="checkbox-label" for="approvalNoReceipts">Blanket approval for no receipts</label>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="checkbox-wrap">
          <div class="form-group">
            <label class="checkbox">
              <input formControlName="fixedFeePerVisit" id="fixedFeePerVisit" type="checkbox">
              <span></span>
            </label>
            <label class="checkbox-label" for="fixedFeePerVisit">Fixed fee per visit</label>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="checkbox-wrap">
          <div class="form-group">
            <label class="checkbox">
              <input formControlName="overspendTravel" id="overspendTravel" type="checkbox">
              <span></span>
            </label>
            <label class="checkbox-label" for="overspendTravel">Blanket approval for overspend on
              travel</label>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="checkbox-wrap">
          <div class="form-group">
            <label class="checkbox">
              <input formControlName="overspendMileage" id="overspendMileage" type="checkbox">
              <span></span>
            </label>
            <label class="checkbox-label" for="overspendMileage">Blanket approval for
              overspend on mileage</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-modal #changeSiteModal>
    <div class="modal-header">
      <h2 class="modal-title">Change Site</h2>
    </div>
    <div class="modal-body" style="padding: 30px;">
      <p>Changing the site will have the following effects:</p>
      <ul style="font-size: 12px; display: flex; flex-direction: column; gap: 5px;">
        <ng-container *ngFor="let item of changeSitePreview?.impacts; let i = index">
          <li *ngIf="changeSitePreview?.actionable" style="padding-left: 20px; position: relative;">
            <i class="far fa-angle-right" style="position:absolute; top: 2px; left: 0; color: var(--primary-color);"></i> {{ item }}
          </li>
          <li *ngIf="!changeSitePreview?.actionable" style="padding-left: 20px; position: relative;"
              [class.change-site-blocker]="i === changeSitePreview.impacts.length - 1">
            <i class="far fa-angle-right" style="position:absolute; top: 2px; left: 0;"
               [style.color]="i === changeSitePreview.impacts.length - 1 ? '#D44618' : 'var(--primary-color)'"></i> {{ item }}
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="onCancelChangeSite()" class="btn btn-secondary">Cancel</a>
        </div>
        <div class="col-6">
          <button (click)="onConfirmChangeSite()" class="btn btn-primary" [disabled]="!changeSitePreview?.actionable">Ok</button>
        </div>
      </div>
    </div>
  </app-modal>

  <!-- Consent / Action buttons-->
  <div class="row" *ngIf="patientTrial === null">
    <div class="col-6">
      <div class="checkbox-wrap last" style="margin-left: -15px;">
        <div class="form-group">
          <label class="checkbox">
            <input formControlName="consent" id="consent" type="checkbox">
            <span></span>
          </label>
          <label class="checkbox-label" for="consent">I confirm that I have seen and verified patient consent</label>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="buttons">
        <button (click)="onCancel()" class="btn btn-secondary" type="button">Cancel</button>
        <button (click)="onTrialAdded()" [disabled]="!parentForm.valid" class="btn btn-primary" type="button">Add Trial</button>
      </div>
    </div>
  </div>
</div>
